module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"indoor":"内部発生","outdoor":"外部侵入"},"en":{"indoor":"indoor","outdoor":"outdoor"}}')
  delete Component.options._Ctor
}
